import { RDConservationProgramsList } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDConservationProgramsListEditor } from './ConservationProgramsListEditor'

export const ConservationProgramsListTaskDefinition: ResourceDetailFeature<RDConservationProgramsList> =
  {
    traitId: 'conservationPrograms',
    TaskEditor: RDConservationProgramsListEditor,
  }
